/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.viewer.skins.TPA3DCarouselSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPA3DGallerySkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAAccordionSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPACollageSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAEcomGallerySkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAFreestyleSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAHoneycombSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAImpressSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAMasonrySkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAStripShowcaseSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAStripSlideshowSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}
 skins['wysiwyg.viewer.skins.TPAThumbnailsSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "allowFullScreen": true,
        "frameBorder": 0,
        "scrolling": "no",
        "allowtransparency": "true"
      }
    ]
  ],
  "css": {
    "%iframe": "overflow:hidden;position:absolute;width:100%;height:100%;display:block;",
    "%[data-state~=\"iframeNotShown\"] %iframe": "display:none;",
    "%[data-state~=\"iframeRenderedInvisible\"] %iframe": "visibility:hidden;"
  }
}

    return skins;
});
